"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  [![Run in Postman](https://run.pstmn.io/button.svg)](https://app.getpostman.com/run-collection/614feab5c108d292bffa#?env%5BStacks%20Blockchain%20API%5D=W3sia2V5Ijoic3R4X2FkZHJlc3MiLCJ2YWx1ZSI6IlNUMlRKUkhESE1ZQlE0MTdIRkIwQkRYNDMwVFFBNVBYUlg2NDk1RzFWIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJibG9ja19pZCIsInZhbHVlIjoiMHgiLCJlbmFibGVkIjp0cnVlfSx7ImtleSI6Im9mZnNldCIsInZhbHVlIjoiMCIsImVuYWJsZWQiOnRydWV9LHsia2V5IjoibGltaXRfdHgiLCJ2YWx1ZSI6IjIwMCIsImVuYWJsZWQiOnRydWV9LHsia2V5IjoibGltaXRfYmxvY2siLCJ2YWx1ZSI6IjMwIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJ0eF9pZCIsInZhbHVlIjoiMHg1NDA5MGMxNmE3MDJiNzUzYjQzMTE0ZTg4NGJjMTlhODBhNzk2MzhmZDQ0OWE0MGY4MDY4Y2RmMDAzY2RlNmUwIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJjb250cmFjdF9pZCIsInZhbHVlIjoiU1RKVFhFSlBKUFBWRE5BOUIwNTJOU1JSQkdRQ0ZOS1ZTMTc4VkdIMS5oZWxsb193b3JsZFxuIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJidGNfYWRkcmVzcyIsInZhbHVlIjoiYWJjIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJjb250cmFjdF9hZGRyZXNzIiwidmFsdWUiOiJTVEpUWEVKUEpQUFZETkE5QjA1Mk5TUlJCR1FDRk5LVlMxNzhWR0gxIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJjb250cmFjdF9uYW1lIiwidmFsdWUiOiJoZWxsb193b3JsZCIsImVuYWJsZWQiOnRydWV9LHsia2V5IjoiY29udHJhY3RfbWFwIiwidmFsdWUiOiJzdG9yZSIsImVuYWJsZWQiOnRydWV9LHsia2V5IjoiY29udHJhY3RfbWV0aG9kIiwidmFsdWUiOiJnZXQtdmFsdWUiLCJlbmFibGVkIjp0cnVlfV0=)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BnsApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class BnsApi extends runtime.BaseAPI {
    /**
     * Fetch a user’s raw zone file. This only works for RFC-compliant zone files. This method returns an error for names that have non-standard zone files.
     */
    async fetchZoneFileRaw(requestParameters) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling fetchZoneFile.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/names/{name}/zonefile`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Fetch a user’s raw zone file. This only works for RFC-compliant zone files. This method returns an error for names that have non-standard zone files.
     */
    async fetchZoneFile(requestParameters) {
        const response = await this.fetchZoneFileRaw(requestParameters);
        return await response.value();
    }
    /**
     * Fetch a list of all names known to the node.
     */
    async getAllNamesRaw(requestParameters) {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling getAllNames.');
        }
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/names`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Fetch a list of all names known to the node.
     */
    async getAllNames(requestParameters) {
        const response = await this.getAllNamesRaw(requestParameters);
        return await response.value();
    }
    /**
     * Fetch a list of all namespaces known to the node.
     */
    async getAllNamespacesRaw() {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/namespaces`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.BnsGetAllNamespacesResponseFromJSON(jsonValue));
    }
    /**
     * Fetch a list of all namespaces known to the node.
     */
    async getAllNamespaces() {
        const response = await this.getAllNamespacesRaw();
        return await response.value();
    }
    /**
     * Fetch a list of all subdomains known to the node.
     */
    async getAllSubdomainsRaw(requestParameters) {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling getAllSubdomains.');
        }
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/subdomains`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Fetch a list of all subdomains known to the node.
     */
    async getAllSubdomains(requestParameters) {
        const response = await this.getAllSubdomainsRaw(requestParameters);
        return await response.value();
    }
    /**
     * Fetches the historical zonefile specified by the username and zone hash.
     */
    async getHistoricalZoneFileRaw(requestParameters) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getHistoricalZoneFile.');
        }
        if (requestParameters.zoneFileHash === null || requestParameters.zoneFileHash === undefined) {
            throw new runtime.RequiredError('zoneFileHash', 'Required parameter requestParameters.zoneFileHash was null or undefined when calling getHistoricalZoneFile.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/names/{name}/zonefile/{zoneFileHash}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"zoneFileHash"}}`, encodeURIComponent(String(requestParameters.zoneFileHash))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Fetches the historical zonefile specified by the username and zone hash.
     */
    async getHistoricalZoneFile(requestParameters) {
        const response = await this.getHistoricalZoneFileRaw(requestParameters);
        return await response.value();
    }
    /**
     * Get a history of all blockchain records of a registered name.
     */
    async getNameHistoryRaw(requestParameters) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getNameHistory.');
        }
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling getNameHistory.');
        }
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/names/{name}/history`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a history of all blockchain records of a registered name.
     */
    async getNameHistory(requestParameters) {
        const response = await this.getNameHistoryRaw(requestParameters);
        return await response.value();
    }
    /**
     * Fetch name details.
     */
    async getNameInfoRaw(requestParameters) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getNameInfo.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/names/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.BnsGetNameInfoResponseFromJSON(jsonValue));
    }
    /**
     * Fetch name details.
     */
    async getNameInfo(requestParameters) {
        const response = await this.getNameInfoRaw(requestParameters);
        return await response.value();
    }
    /**
     * Get the price of a name. The `amount` given will be in the smallest possible units of the currency.
     */
    async getNamePriceRaw(requestParameters) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getNamePrice.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v2/prices/names/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.BnsGetNamePriceResponseFromJSON(jsonValue));
    }
    /**
     * Get the price of a name. The `amount` given will be in the smallest possible units of the currency.
     */
    async getNamePrice(requestParameters) {
        const response = await this.getNamePriceRaw(requestParameters);
        return await response.value();
    }
    /**
     * Retrieves a list of names owned by the address provided.
     */
    async getNamesOwnedByAddressRaw(requestParameters) {
        if (requestParameters.blockchain === null || requestParameters.blockchain === undefined) {
            throw new runtime.RequiredError('blockchain', 'Required parameter requestParameters.blockchain was null or undefined when calling getNamesOwnedByAddress.');
        }
        if (requestParameters.address === null || requestParameters.address === undefined) {
            throw new runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling getNamesOwnedByAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/addresses/{blockchain}/{address}`.replace(`{${"blockchain"}}`, encodeURIComponent(String(requestParameters.blockchain))).replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.BnsNamesOwnByAddressResponseFromJSON(jsonValue));
    }
    /**
     * Retrieves a list of names owned by the address provided.
     */
    async getNamesOwnedByAddress(requestParameters) {
        const response = await this.getNamesOwnedByAddressRaw(requestParameters);
        return await response.value();
    }
    /**
     * Fetch a list of names from the namespace.
     */
    async getNamespaceNamesRaw(requestParameters) {
        if (requestParameters.tld === null || requestParameters.tld === undefined) {
            throw new runtime.RequiredError('tld', 'Required parameter requestParameters.tld was null or undefined when calling getNamespaceNames.');
        }
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling getNamespaceNames.');
        }
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/namespaces/{tld}/names`.replace(`{${"tld"}}`, encodeURIComponent(String(requestParameters.tld))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Fetch a list of names from the namespace.
     */
    async getNamespaceNames(requestParameters) {
        const response = await this.getNamespaceNamesRaw(requestParameters);
        return await response.value();
    }
    /**
     * Get the price of a namespace. The `amount` given will be in the smallest possible units of the currency.
     */
    async getNamespacePriceRaw(requestParameters) {
        if (requestParameters.tld === null || requestParameters.tld === undefined) {
            throw new runtime.RequiredError('tld', 'Required parameter requestParameters.tld was null or undefined when calling getNamespacePrice.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v2/prices/namespaces/{tld}`.replace(`{${"tld"}}`, encodeURIComponent(String(requestParameters.tld))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.BnsGetNamespacePriceResponseFromJSON(jsonValue));
    }
    /**
     * Get the price of a namespace. The `amount` given will be in the smallest possible units of the currency.
     */
    async getNamespacePrice(requestParameters) {
        const response = await this.getNamespacePriceRaw(requestParameters);
        return await response.value();
    }
    /**
     * Fetches the list of subdomain operations processed by a given transaction. The returned array includes subdomain operations that have not yet been accepted as part of any subdomain’s history (checkable via the accepted field). If the given transaction ID does not correspond to a Blockstack transaction that introduced new subdomain operations, and empty array will be returned.
     */
    async getSubdomainAtTransactionRaw(requestParameters) {
        if (requestParameters.txid === null || requestParameters.txid === undefined) {
            throw new runtime.RequiredError('txid', 'Required parameter requestParameters.txid was null or undefined when calling getSubdomainAtTransaction.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v1/subdomains/{txid}`.replace(`{${"txid"}}`, encodeURIComponent(String(requestParameters.txid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.InlineResponse200FromJSON));
    }
    /**
     * Fetches the list of subdomain operations processed by a given transaction. The returned array includes subdomain operations that have not yet been accepted as part of any subdomain’s history (checkable via the accepted field). If the given transaction ID does not correspond to a Blockstack transaction that introduced new subdomain operations, and empty array will be returned.
     */
    async getSubdomainAtTransaction(requestParameters) {
        const response = await this.getSubdomainAtTransactionRaw(requestParameters);
        return await response.value();
    }
}
exports.BnsApi = BnsApi;
//# sourceMappingURL=BnsApi.js.map